import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import {
    fetchProducts,
    fetchProductById
} from "../services/productService"

export const getProducts = createAsyncThunk(
    "products/getProducts",
    async (_Readable, thunkAPI) =>{
        try{
            return await fetchProducts();
        }catch(error){
            return thunkAPI.rejectWithValue(
                error.message
            )
        }
    }
);

export const getProductById = createAsyncThunk(
    "products/getProductById",
    async (id, thunkAPI) =>{
        try{
             return await fetchProductById(id);
        }catch(error){
            return thunkAPI.rejectWithValue(
                error.message
            );
        }
    }
)

const initialState = {
    products: [],
    product: null,
    loading: false,
    error:null
}

const productSlice = createSlice({
    name: "products",
    initialState,
    reducers:{
        clearProduct: (state) =>{
            state.product = null;
        }
    },
    extraReducers: (builder) =>{
        builder
        .addCase(
           getProducts.pending,
           (state) => {
              state.loading = true;
              state.error = null
           }
        )
        .addCase(
            getProducts.rejected,
            (state, action) =>{
                state.loading = false;
                state.error = action.payload;
            }
        )
        .addCase(
            getProducts.fulfilled,
            (state, action) =>{
                state.loading = false;
                state.products = action.payload
            }
        )
        .addCase(
            getProductById.fulfilled,
            (state, action) =>{
                state.loading = false;
                state.product = action.payload;
            }
        )
        .addCase(
            getProductById.pending,
            (state,action) =>{
              state.loading = true;
              state.error = null
            }
        )
        .addCase(
            getProductById.rejected,
            (state,action) =>{
                state.loading = false;
                state.error = action.payload;
            }
        )
    }
});

export const {
    clearProduct
} = productSlice.actions;

export default productSlice.reducer;